import { Box, styled } from "@mui/material";
import React, { useContext, useEffect } from "react";

import { vehicles } from "../../constants/vehicleData";
import { Context } from "../../context/context";
import { getCookie } from "../../utils/cookie";
import { MemoizedFAQ } from "../Lead Capture/FAQ/faq";
import MemoizedVehicleCard from "./VehicleCard";

const CustomerVehiclesPage = styled(Box)(({ theme }) => ({
  position: "relative",
  top: "-80px",
  [theme.breakpoints.down("md")]: {
    top: "-40px",
  },
}));

const OldVehicles = () => {
  const { showWhatsappPopup } = useContext(Context);
  let cacheInfoSlider = getCookie("user_slided")
    ? JSON.parse(getCookie("user_slided"))
    : "";
  let cacheInfoUser = getCookie("user_verified")
    ? JSON.parse(getCookie("user_verified"))
    : "";

  // useEffect(() => {
  //   sendAnalytics("screen_viewed", { screen_name: "vehicle selection" }, "en");
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  useEffect(() => {
    if (
      localStorage?.getItem("phoneInfo") === null &&
      cacheInfoSlider?.slided === true &&
      cacheInfoUser?.verified !== true
    ) {
      showWhatsappPopup("Image_slided");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <CustomerVehiclesPage>
      {vehicles?.map((item, index) => {
        return (
          <MemoizedVehicleCard key={index} vehicleData={item} index={index} />
        );
      })}
      <MemoizedFAQ />
    </CustomerVehiclesPage>
  );
};

export const MemoizedOldVehicles = React.memo(OldVehicles);
